export default __webpack_public_path__ + "static/media/binangonan.179aa8ec.jpg";